import React from "react";

const AuditoriaFiltroForm = ({
  filtros,
  onChange,
  onSubmit,
  onClear,
  cargando,
}) => (
  <form className="form-container" onSubmit={onSubmit}>
    <div className="filtro-campos">
      <div className="filtro-grupo">
        <label htmlFor="auditoria-usuario">Usuario</label>
        <input
          id="auditoria-usuario"
          type="text"
          name="usuario"
          value={filtros.usuario}
          onChange={onChange}
          disabled={cargando}
          className="filtro-input"
          placeholder="Correo o nombre"
        />
      </div>

      <div className="filtro-grupo fecha-grupo">
        <label htmlFor="auditoria-fecha-desde">Fecha desde</label>
        <input
          id="auditoria-fecha-desde"
          type="date"
          name="fechaDesde"
          value={filtros.fechaDesde}
          onChange={onChange}
          disabled={cargando}
          className="filtro-input"
        />
      </div>

      <div className="filtro-grupo fecha-grupo">
        <label htmlFor="auditoria-fecha-hasta">Fecha hasta</label>
        <input
          id="auditoria-fecha-hasta"
          type="date"
          name="fechaHasta"
          value={filtros.fechaHasta}
          onChange={onChange}
          disabled={cargando}
          className="filtro-input"
        />
      </div>

      <div className="filtro-grupo">
        <label htmlFor="auditoria-centro-costos">
          Centro de costos <span className="filtro-opcional">(opcional)</span>
        </label>
        <input
          id="auditoria-centro-costos"
          type="text"
          name="centroCostos"
          value={filtros.centroCostos || ""}
          onChange={onChange}
          disabled={cargando}
          className="filtro-input"
          placeholder="Ej. 55"
          inputMode="numeric"
        />
      </div>

      <div className="filtro-grupo">
        <label htmlFor="auditoria-terminal">
          Terminal <span className="filtro-opcional">(opcional)</span>
        </label>
        <input
          id="auditoria-terminal"
          type="text"
          name="terminal"
          value={filtros.terminal || ""}
          onChange={onChange}
          disabled={cargando}
          className="filtro-input"
          placeholder="Código terminal"
        />
      </div>
    </div>

    <div className="buttons-container">
      <button type="submit" className="btn-primary" disabled={cargando}>
        {cargando ? "Consultando..." : "Buscar"}
      </button>
      <button
        type="button"
        className="btn-secondary"
        onClick={onClear}
        disabled={cargando}
      >
        Limpiar
      </button>
    </div>
  </form>
);

export default AuditoriaFiltroForm;
